<div class="glass-panel border border-gray-200 dark:border-white/10" [ngClass]="paddingClass">
  <ng-content></ng-content>
</div>
